import styled from 'styled-components/macro';

/**
 * This media component is an abstraction to easily align icons/images with a bigger block next to it
 * See: http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code/ for
 * the original article introducing this pattern.
 * Check out https://philipwalton.github.io/solved-by-flexbox/demos/media-object/ for implementation details
 *
 *    <MediaWrapper> starts here and contains MediaFigure and MediaBody as children
 *    ____________________________________________________
 *
 *    <MediaFigure>  |   <MediaBody> starts here
 *    is a small     |   and will extend down
 *    icon           |   and down and down
 *                   |    until it reaches the bottom
 *    ____________________________________________________
 */

export const Media = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const MediaFigure = styled.div`
  margin-right: 0.5em;
`;

export const MediaBody = styled.div`
  flex: 1 1 auto;
`;
